var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSearchTextDark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 44"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#777",
  fillRule: "evenodd",
  clipPath: "url(#icon_search_text_dark_svg__a)",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.163 15.18a8.016 8.016 0 1 1 16.033 0 8.016 8.016 0 0 1-16.033 0m8.017-6.404a6.405 6.405 0 1 0 0 12.81 6.405 6.405 0 0 0 0-12.81"
}), /*#__PURE__*/React.createElement("path", {
  d: "m32.524 25.665-4.507-4.506 1.14-1.14 4.506 4.507z"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#777",
  d: "M20.201 31.627c0 2.226-1.528 3.804-4.062 4.521l-.381-.722c2.021-.567 3.271-1.656 3.452-3.037h-2.993v-.762zm-2.949 8.086v-3.31h5.723v3.31zm.908-.742h3.897v-1.826H18.16zm2.08-4.922v-.772h1.807V31.09h.928v4.951h-.928v-1.992zm6.758-1.319c0 .987.605 1.968 1.738 2.413l-.498.712a3.05 3.05 0 0 1-1.684-1.665c-.323.82-.918 1.524-1.763 1.89l-.508-.713c1.182-.517 1.817-1.645 1.817-2.636v-1.124h.898zm-1.162 4.854v-.752h5.947v2.998h-.918v-2.246zm3.184-1.26v-5.088h.859v2.08h1.025V31.09h.88v5.283h-.88v-2.285H29.88v2.236z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon_search_text_dark_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11 3h26v26H11z"
})))));
export default SvgIconSearchTextDark;